import { render, staticRenderFns } from "./ProposalCp.vue?vue&type=template&id=05640626&scoped=true&"
import script from "./ProposalCp.vue?vue&type=script&lang=js&"
export * from "./ProposalCp.vue?vue&type=script&lang=js&"
import style0 from "./ProposalCp.vue?vue&type=style&index=0&id=05640626&prod&lang=css&"
import style1 from "./ProposalCp.vue?vue&type=style&index=1&id=05640626&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05640626",
  null
  
)

export default component.exports